export const CHECKOUT_URL = 'https://volleyball-coach-pro.impultienda.ar/checkout'

export const OFFER_ANCHOR = '#offer'

export const PRODUCT_NAME = 'VOLLEYBALL COACH PRO™'

export const PRODUCT_IMG =
  'https://cdn.magicpatterns.com/uploads/8sa8Ht7XJAWA3C676DE1Wy/ChatGPT_Image_16_ago_2026,_07_40_25_p.m..png'

export const PRODUCT_ALT =
  'VOLLEYBALL COACH PRO™ — complete 6-in-1 ready-to-use volleyball coaching system box set'

export const PRICE_FULL = '$97'

export const PRICE_TODAY = '$27'

export const SUPPORT_EMAIL = 'kitonline27@gmail.com'
